import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID } from 'class-validator'

/**
 * DTO pour la validation batch de leçons
 */
export class ValidateLessonsBatchRequestDto {
  @ApiProperty({
    type: 'string',
    description: "ID de l'utilisateur",
    format: 'uuid',
  })
  @IsUUID()
  userId!: string

  @ApiProperty({
    description: 'IDs des leçons à valider',
    type: [String],
  })
  @IsArray()
  @IsUUID(undefined, { each: true })
  lessonIds!: string[]
}

/**
 * Résultat de validation pour une leçon
 */
export interface LessonValidationResult {
  id: string
  accessible: boolean
  establishmentId?: string
  teachingIds?: string[]
  reason?: string
}

/**
 * Réponse de validation batch
 */
export class ValidateLessonsBatchResponseDto {
  @ApiProperty({
    type: Boolean,
    description: 'Toutes les leçons sont accessibles',
  })
  valid!: boolean

  @ApiProperty({
    type: [Object],
    description: 'Résultats détaillés par leçon',
  })
  lessons!: LessonValidationResult[]
}
